function same(a: unknown, b: unknown): boolean {
  return JSON.stringify(a) === JSON.stringify(b)
}

/** What was read, except the reporter's value for anything they changed — and all of a group they touched. */
export function mergeExtractedValues<T extends object>(
  read: T,
  current: T,
  initial: T,
  groups: readonly (readonly (keyof T)[])[] = []
): T {
  const touched = (field: keyof T) => !same(current[field], initial[field])
  const merged = { ...read }
  for (const field of Object.keys(current) as (keyof T)[]) {
    if (touched(field)) merged[field] = current[field]
  }
  for (const group of groups) {
    if (group.some(touched)) for (const field of group) merged[field] = current[field]
  }
  return merged
}
